import React from 'react'
import PropTypes from 'prop-types'
import ContentfulButton from './Buttons/ContentfulButton'

function ContentfulForm({ data }) {
  const { endpointUrl, method, formFields } = data

  /* eslint-disable react/no-array-index-key */
  return (
    <form action={endpointUrl} method={method}>
      {formFields?.length &&
        formFields.map((el, index) => {
          const typeName = el.__typename

          if (typeName === 'ContentfulFormTextbox')
            return (
              <input type="text" key={index} placeholder={el.placeholderText} name={el.fieldId} />
            )

          if (typeName === 'ContentfulButton') return <ContentfulButton data={el} key={index} />

          return null
        })}
    </form>
  )
}

ContentfulForm.propTypes = {
  data: PropTypes.object.isRequired
}

export default ContentfulForm
